import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './MessageForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';
import DropdownButton from 'component/atom/forms/dropdown-button/DropdownButton';
import { usePost } from 'hooks/usePost';
import { workflow } from 'hooks/endpoints';
import { useUpdateNodeInternals } from '@xyflow/react';
import toast from 'react-hot-toast';

const MessageForm = ({ id }) => {
  const formik = useFormikContext();
  const [editingIndex, setEditingIndex] = useState(null);

  const { mutate: generateMessageVariants, isPending } = usePost();

  const handleGenerateMessageVariants = (message) => {
    generateMessageVariants(
      {
        url: workflow.autoGenerateMessageVariants,
        data: { message: message },
        isFormData: false,
      },
      {
        onSuccess: (data) => {
          const cleanedVariants = (data?.data?.result || []).filter(
            (v) => v.trim() !== ''
          );
          formik.setFieldValue('messageVariant', cleanedVariants);
        },
      }
    );
  };

  return (
    <form
      className={styles['message-form']}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <div className={styles['editor-container']}>
        <TextEditor
          placeholder="Enter your custom message..."
          name="message"
          value={formik.values.message}
          onChange={(value) => formik.setFieldValue('message', value)}
          error={formik.errors.message}
          touched={formik.touched.message}
          rows="15"
          className={styles['editor']}
          isCustom
          isToolbarReduced
          textEditorClassName={styles['editor-class']}
        />
      </div>

      <div className={styles['variants-container']}>
        <div className={styles['message-wrapper']}>
          <div className={styles['variants']}>
            <p>Variants</p>
            {/* <DropdownButton
              items={Variants.map((variant) => ({
                ...variant,
                function: () => {
                  const newVariant = {
                    id: new Date().getTime(),
                    label: variant.label,
                    content: '',
                  };
                  formik.setFieldValue('messageVariant', [
                    ...formik.values.messageVariant,
                    newVariant,
                  ]);
                  setEditingIndex(formik.values.messageVariant.length);
                },
              }))}
              type="plus"
              position="left"
              isButton
              isTransparent
            /> */}

            <Button
              type="plus"
              className={styles['button']}
              buttonType="button"
              transparent
              onClick={() => {
                formik.setFieldValue('messageVariant', [
                  ...(formik.values.messageVariant || []),
                  '',
                ]);
                setEditingIndex(formik.values.messageVariant.length);
              }}
            />
          </div>

          {formik.values.messageVariant.map((variant, index) => (
            <div key={index}>
              {editingIndex === index ? (
                <TextEditor
                  placeholder="Edit your variant text..."
                  name={`messageVariant.${index}`}
                  value={variant}
                  onChange={(value) => {
                    const updatedVariants = [...formik.values.messageVariant];

                    updatedVariants[index] = value;
                    formik.setFieldValue('messageVariant', updatedVariants);
                  }}
                  rows="10"
                  className={styles['editor']}
                  isCustom
                  isToolbarReduced
                  isSave
                  onSaveClick={() => {
                    const filteredVariants =
                      formik.values.messageVariant.filter(
                        (v) => v.trim() !== '' && v.trim() !== '<p><br></p>'
                      );
                    formik.setFieldValue('messageVariant', filteredVariants);
                    setEditingIndex(null);
                  }}
                  errors={formik.errors?.messageVariant?.[index]}
                  touched={formik.touched?.messageVariant?.[index]}
                  textEditorClassName={styles['editor-class']}
                />
              ) : (
                <div className={styles['variant-display']}>
                  <div
                    className={styles['variant-content']}
                    dangerouslySetInnerHTML={{
                      __html: variant || '<p>No content</p>',
                    }}
                  ></div>
                  <div className={styles['variant-action']}>
                    <SvgWithBranding
                      type="edit"
                      className={styles.icon}
                      onClick={() => setEditingIndex(index)}
                    />
                    <SvgWithBranding
                      type="delete_table"
                      className={styles.icon}
                      onClick={() => {
                        const updatedVariants =
                          formik.values.messageVariant.filter(
                            (_, i) => i !== index
                          );
                        formik.setFieldValue('messageVariant', updatedVariants);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

          <Button
            buttonType="button"
            label="Auto Generate"
            className={styles['generate-button']}
            onClick={() => {
              if (formik?.values?.message == '') {
                toast.error('Fill Message field before Auto Generate');
              } else {
                handleGenerateMessageVariants(formik.values.message);
              }
            }}
            isLoading={isPending}
          />
        </div>
      </div>
    </form>
  );
};

export default MessageForm;
